import { render, staticRenderFns } from "./EventAndTipsSection.vue?vue&type=template&id=b9798284&scoped=true&"
import script from "./EventAndTipsSection.vue?vue&type=script&lang=js&"
export * from "./EventAndTipsSection.vue?vue&type=script&lang=js&"
import style0 from "./EventAndTipsSection.vue?vue&type=style&index=0&id=b9798284&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9798284",
  null
  
)

export default component.exports